var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressbar"},[_c('div',{staticClass:"progressbar-inner",style:('width:'+Math.min(_vm.value||0, 100)+'%')},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }